module.exports = __webpack_public_path__ + "media/images/about-us/PGA/Pacific NorthWest PGA-ec2407c000a61a4e722191c50234ac85.png";